export const tagsModes = {
  or: "or",
  and: "and",
};

export const tagFilter = {
  all: "all",
  active: "active",
};
